"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils/utils");
var _Button = _interopRequireDefault(require("./Button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TooltipCoachmark = /*#__PURE__*/function (_Component) {
  function TooltipCoachmark(props) {
    var _this;
    _classCallCheck(this, TooltipCoachmark);
    _this = _callSuper(this, TooltipCoachmark, [props]);
    _this.myRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = _objectSpread({
      state: props.state || "hide",
      defaultEvent: props.defaultEvent,
      x: 0,
      y: 0,
      currentStep: 1,
      lastStep: false,
      pagination: ""
    }, props.restOfState);
    _this.getContext = _this.getContext.bind(_this);
    _this.updateTooltip = _this.updateTooltip.bind(_this);
    _this.setEvent = _this.setEvent.bind(_this);
    _this.removeEvent = _this.removeEvent.bind(_this);
    _this.event = _this.event.bind(_this);
    _this.isTargetTooltip = _this.isTargetTooltip.bind(_this);
    _this.showStep = _this.showStep.bind(_this);
    _this.nextPrev = _this.nextPrev.bind(_this);
    return _this;
  }
  _inherits(TooltipCoachmark, _Component);
  return _createClass(TooltipCoachmark, [{
    key: "show",
    value: function show() {
      var onlyEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.state.defaultEvent) {
        if (onlyEvent && this.state.state === "show" || !onlyEvent && this.state.state === "hide") {
          document.addEventListener("click", this.isTargetTooltip, false);
        }
      }
      if (!onlyEvent) {
        this.setState({
          state: "show"
        });
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var onlyEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.state.defaultEvent) {
        if (onlyEvent && this.state.state === "hide" || !onlyEvent && this.state.state === "show") {
          document.removeEventListener("click", this.isTargetTooltip, false);
        }
      }
      if (!onlyEvent) {
        this.setState({
          state: "hide"
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var steps = false;
      if (this.props.type === 'coachmark-text-steps') {
        steps = true;
        this.showStep(this.state.currentStep); // Display the current step
      }
      this.updateTooltip(steps);
      if (!this.props.isControlled) {
        this.setEvent();
      }
      if (this.state.state === "show") {
        this.show(true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.defaultEvent) {
        var context;
        if (this.props.context) {
          context = this.getContext();
        } else {
          context = this.myRef.current.parentElement;
        }
        if (context) {
          context.removeEventListener("mouseenter", this.event);
          context.removeEventListener("mouseleave", this.event);
        }
      } else {
        document.removeEventListener("click", this.isTargetTooltip, false);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.state === "hide" && this.state.state === "show") {
        var steps = false;
        if (this.props.type === 'coachmark-text-steps') {
          steps = true;
        }
        this.updateTooltip(steps);
      }
      if (this.props.type === 'coachmark-text-steps' && prevState.currentStep != this.state.currentStep) {
        this.updateTooltip(true);
      }
      if (prevState.state !== this.state.state) {
        if (this.state.state === "show") {
          this.show(true);
        } else {
          this.hide(true);
        }
      }
    }
  }, {
    key: "isTargetTooltip",
    value: function isTargetTooltip(event) {
      if (!(0, _utils.Contains)(this.myRef.current, event.target)) {
        this.hide();
      }
    }
  }, {
    key: "setEvent",
    value: function setEvent() {
      if (!this.state.defaultEvent) {
        if (this.state.state === "show") {
          document.addEventListener("click", this.isTargetTooltip, false);
        }
        return;
      }
      var context;
      if (this.props.context) {
        context = this.getContext();
      } else {
        context = this.myRef.current.parentElement;
      }
      if (context) {
        context.addEventListener("mouseenter", this.event);
        context.addEventListener("mouseleave", this.event);
      }
    }
  }, {
    key: "removeEvent",
    value: function removeEvent() {
      if (!this.state.defaultEvent) {
        document.removeEventListener("click", this.isTargetTooltip, false);
        return;
      }
      var context;
      if (this.props.context) {
        context = this.getContext();
      } else {
        context = this.myRef.current.parentElement;
      }
      if (context) {
        context.removeEventListener("mouseenter", this.event);
        context.removeEventListener("mouseleave", this.event);
      }
    }
  }, {
    key: "event",
    value: function event(_event) {
      var steps = false;
      if (this.props.type === 'coachmark-text-steps') {
        steps = true;
      }
      switch (_event.type) {
        case "mouseenter":
          this.updateTooltip(steps);
          this.setState({
            state: "show"
          });
          break;
        case "mouseleave":
          this.setState({
            state: "hide"
          });
          break;
      }
    }
  }, {
    key: "getContext",
    value: function getContext() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.props.context) return null;
      var context;
      if (steps) {
        var currentStep = this.state.currentStep;
        context = document.querySelector(this.props.context[currentStep - 1]);
      } else {
        context = document.querySelector(this.props.context);
      }
      return context;
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var tooltip = this.myRef.current;
      var x = 0;
      var y = 0;
      var currentStep = this.state.currentStep;
      if (steps && this.props.type === 'coachmark-text-steps') {
        var context = this.getContext(true);
        if (this.props.context[currentStep - 1] != "" && context) {
          var position = this.props.position[currentStep - 1] || "top";
          switch (position) {
            case "top":
              if (this.props.arrowPosition[currentStep - 1] === "arrow-left") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-right") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
              }
              y = context.offsetTop - tooltip.offsetHeight - 5;
              break;
            case "right":
              x = context.offsetLeft + context.offsetWidth + 5;
              if (this.props.arrowPosition[currentStep - 1] === "arrow-top") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-bottom") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
              }
              break;
            case "bottom":
              if (this.props.arrowPosition[currentStep - 1] === "arrow-left") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-right") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
              }
              y = context.offsetTop + context.offsetHeight + 5;
              break;
            case "left":
              x = context.offsetLeft - tooltip.offsetWidth - 5;
              if (this.props.arrowPosition[currentStep - 1] === "arrow-top") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-bottom") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
              }
              break;
          }
        }
      } else {
        var _context = this.getContext();
        if (this.props.context != "" && _context) {
          var _position = this.props.position || "top";
          switch (_position) {
            case "top":
              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-left") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
                } else if (this.props.arrowPosition === "arrow-right") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
                }
              } else {
                x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth / 2;
              }
              y = _context.offsetTop - tooltip.offsetHeight - 5;
              break;
            case "right":
              x = _context.offsetLeft + _context.offsetWidth + 5;
              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-top") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
                } else if (this.props.arrowPosition === "arrow-bottom") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
                }
              } else {
                y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight / 2;
              }
              break;
            case "bottom":
              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-left") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
                } else if (this.props.arrowPosition === "arrow-right") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
                }
              } else {
                x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth / 2;
              }
              y = _context.offsetTop + _context.offsetHeight + 5;
              break;
            case "left":
              x = _context.offsetLeft - tooltip.offsetWidth - 5;
              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-top") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
                } else if (this.props.arrowPosition === "arrow-bottom") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
                }
              } else {
                y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight / 2;
              }
              break;
          }
        }
      }
      this.setState({
        x: x + this.props.adjustedXY.x,
        y: y + this.props.adjustedXY.y
      });
    }
  }, {
    key: "showStep",
    value: function showStep(n) {
      if (n == 1) {
        document.getElementById("prevBtn").style.display = "none";
      } else {
        document.getElementById("prevBtn").style.display = "inline";
      }
      this.setState({
        pagination: n + " of " + this.props.countSteps
      });
    }
  }, {
    key: "nextPrev",
    value: function nextPrev(n) {
      // Increase or decrease the current step by 1:
      var currentStep = this.state.currentStep + n;
      if (currentStep <= this.props.countSteps) {
        this.setState({
          currentStep: currentStep,
          last: false
        });
        this.updateTooltip(true);
        this.showStep(currentStep);
      }

      // if you have reached the last step
      if (currentStep >= this.props.countSteps) {
        this.setState({
          last: true
        });
        this.updateTooltip(true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var style = _objectSpread({}, this.props.style);
      var currentStep = this.state.currentStep;
      var position = 'top';
      var arrowPosition = '';
      if (this.props.type === 'coachmark-text-steps') {
        position = this.props.position[currentStep - 1] || "top";
        arrowPosition = this.props.arrowPosition[currentStep - 1] || "";
      } else {
        position = this.props.position || "top";
        arrowPosition = this.props.arrowPosition || "";
      }
      if (this.props.context) {
        style.top = this.state.y;
        style.left = this.state.x;
        style = _objectSpread(_objectSpread({}, style), this.props.style);
      }
      var type = this.props.type || "tooltip";
      var color = this.props.color;
      var containerCss = (0, _classnames["default"])("fade", type, position, arrowPosition, color, {
        "in": this.state.state === "show",
        "hide": this.state.state === "hide",
        "noContext": !this.props.context,
        "transform": this.props.transform && this.props.type === "coachmark-icon"
      }, this.props.className);
      if (this.props.type === 'coachmark-text-steps') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "tooltipCoachmark-component"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.myRef,
          className: containerCss,
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "content"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-header"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-title"
        }, this.props.title[currentStep - 1]), this.props.type === 'coachmark-text-steps' && /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-pagination"
        }, this.state.pagination)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-text-content"
        }, this.props.text[currentStep - 1]), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-footer"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-link"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: this.props.linkUrl[currentStep - 1]
        }, this.props.linkLabel[currentStep - 1])), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-nav"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-prev"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          id: "prevBtn",
          onClick: function onClick() {
            return _this2.nextPrev(-1);
          }
        }, this.props.previousLabel)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-button",
          id: "nextBtn"
        }, this.state.last ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          radius: "round",
          colorTheme: "teal",
          shapeStyle: "fill",
          size: "small",
          onClick: this.props.onClick
        }, this.props.buttonLabel[currentStep - 1]) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          radius: "round",
          colorTheme: "teal",
          shapeStyle: "fill",
          size: "small",
          onClick: function onClick() {
            _this2.nextPrev(1);
          }
        }, this.props.buttonLabel[currentStep - 1])))))));
      } else if (this.props.type === 'coachmark-text') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "tooltipCoachmark-component"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.myRef,
          className: containerCss,
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "content"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-title"
        }, this.props.title), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-text-content"
        }, this.props.text), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-footer"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-link"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: this.props.linkUrl
        }, this.props.linkLabel)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-button"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          radius: "round",
          colorTheme: "teal",
          shapeStyle: "fill",
          size: "small",
          onClick: this.props.onClick
        }, this.props.buttonLabel))))));
      } else {
        if (this.props.content) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "tooltipCoachmark-component"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            ref: this.myRef,
            className: containerCss,
            style: style
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "content"
          }, this.props.content)));
        } else {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "tooltipCoachmark-component"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            ref: this.myRef,
            className: containerCss,
            style: style
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "content"
          }, this.props.children)));
        }
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.isControlled && nextProps.state != null && nextProps.state !== state.state) {
        if (nextProps.state === "show") {
          return {
            state: "show"
          };
        } else {
          return {
            state: "hide"
          };
        }
      }
      return null;
    }
  }]);
}(_react.Component);
TooltipCoachmark.propTypes = {
  defaultEvent: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  state: _propTypes["default"].oneOf(["show", "hide"]),
  type: _propTypes["default"].oneOf(["tooltip", "tooltip-text", "coachmark-icon", "coachmark-text", "coachmark-text-steps"]),
  position: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["top", "right", "bottom", "left"]), _propTypes["default"].array]),
  arrowPosition: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["arrow-top", "arrow-right", "arrow-bottom", "arrow-left"]), _propTypes["default"].array]),
  context: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  transform: _propTypes["default"].bool,
  text: _propTypes["default"].any,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  linkLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  linkUrl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  onClick: _propTypes["default"].func,
  countSteps: _propTypes["default"].number,
  color: _propTypes["default"].oneOf(["grey", "red", "coal", "onyx", "white", "teal"]),
  previousLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  buttonLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  adjustedXY: _propTypes["default"].object,
  isControlled: _propTypes["default"].bool
};
TooltipCoachmark.defaultProps = {
  defaultEvent: false,
  color: "grey",
  type: "tooltip",
  position: "top",
  arrowPosition: "arrow-left",
  onClick: function onClick() {},
  previousLabel: "Previous",
  adjustedXY: {
    'x': 0,
    'y': 0
  },
  isControlled: false,
  context: ""
};
var _default = exports["default"] = TooltipCoachmark;